/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';
// @ts-ignore
import PredicateGroup from 'predicates/models/predicate-group';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
export default class ContentPreview extends Model {
  @attr({ defaultValue: () => {} }) declare contentPreviewData: any;
  @attr() declare generatedAt: number;

  @tracked predicateGroup = undefined;

  // Creating a predicate-group fragment inside a getter or component setup causes a crash,
  // so we set it up on the model instead. Deferred to afterRender (matching onLoad below)
  // to avoid a Glimmer auto-tracking assertion when model materialization overlaps with a render pass.
  ready() {
    scheduleOnce('afterRender', this, this.setupPredicateGroup);
  }

  @action onLoad() {
    scheduleOnce('afterRender', this, this.setupPredicateGroup);
  }

  setupPredicateGroup() {
    if (this.contentPreviewData?.predicates) {
      this.predicateGroup = this.store.createFragment('predicates/predicate-group', {
        predicates: PredicateGroup.convertRawPredicates(
          this.store,
          this.contentPreviewData.predicates,
        ),
      });
    }
  }
}
